import React, { useEffect, useState } from 'react'

import { DS } from '@/design-system'
import { useGameOptionsDrawerStore } from './GameOptionsDrawer'
import { translate } from '../../i18n'
import { BaseBottomSheet, Center } from './BaseBottomSheet'

function formatCountdown(msRemaining: number): string {
  const totalSeconds = Math.max(0, Math.ceil(msRemaining / 1000))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

/**
 * Sheet shown when the game is hosted by system and will auto-start at pregameStartAt (scheduled games).
 */
export const StartingInSheet = ({ pregameStartAt }: { pregameStartAt: number }) => {
  const [timeLeft, setTimeLeft] = useState(() => pregameStartAt - Date.now())

  useEffect(() => {
    const tick = () => {
      const remaining = pregameStartAt - Date.now()
      setTimeLeft(remaining)
      if (remaining <= 0) return
    }
    tick()
    const interval = setInterval(tick, 1000)
    return () => clearInterval(interval)
  }, [pregameStartAt])

  const isDrawerOpen = useGameOptionsDrawerStore((state) => state.status === 'open')

  const countdownText = formatCountdown(timeLeft)

  return (
    <BaseBottomSheet dismissOnOverlays={[isDrawerOpen]}>
      <Center style={{ gap: 8 }}>
        <DS.Icon name="Clock" size={32} color="Brand/Dark Grey" />
        <DS.Text variant="Body Large/Medium" color="Brand/Dark Grey" textAlign="center">
          {translate('gameScreen.startingIn', { time: countdownText })}
        </DS.Text>
      </Center>
    </BaseBottomSheet>
  )
}
